import styled from "styled-components";
import { theme } from "../../../../helpers/theme";
import { useParams } from "react-router-dom";
import { GoBackButton } from "../../../../components/GoBackButton";
import StorageAreaEditForm from "./storage-area-edit-form";
import { useQuery } from "@tanstack/react-query";
import { getStorageArea } from "../../../../services/storage-area/get";
import { useState } from "react";
import { GetStorageAreaPayload } from "../../../../services/storage-area/get/types";
import { LoadingBackDrop } from "../../../../components/loader";

const StorageAreaEdit = () => {
  const { id_magazyn, id_obszar } = useParams();
  const [storageArea, setStorageArea] = useState<GetStorageAreaPayload>();
  const StorageAreaGetMutation = useQuery(
    ["StorageArea"],
    () => getStorageArea(id_magazyn),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setStorageArea(data.data.payload);
      },
    }
  );
  const storageAreaToEdit = storageArea?.obszary_skladowania.find(
    (item) => item.id_obszar_skladowania === id_obszar
  );
  if (
    StorageAreaGetMutation.isLoading ||
    StorageAreaGetMutation.isRefetching ||
    storageAreaToEdit === undefined
  ) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
      <ButtonWrapper>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
      </ButtonWrapper>
      <StorageAreaAddContainer>
        <StorageAreaEditForm
          id_obszar_skladowania={id_obszar}
          areaToEdit={storageAreaToEdit}
        />
      </StorageAreaAddContainer>
    </>
  );
};

export default StorageAreaEdit;

const StorageAreaAddContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  padding-top: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: -50px;
  }
`;
const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  // display: flex;
  // justify-content: flex-start;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
  }
`;
